import { gql } from "@apollo/client";

export const DISCONNECT_SLACK_INTEGRATION_FOR_CUSTOMER = gql`
  mutation DisconnectSlackIntegrationForCustomerPrisma {
    disconnectSlack {
      success
      message
      code
      customer {
        id
        slackIntegration {
          id
          type
          connected
          auth0SlackUserId
          autopopulateInterviewer
          needsReauthentication
          notificationsChannelId
          receiveNotifications
        }
      }
    }
  }
`;

export const SYNC_SLACK_PRISMA = gql`
  mutation SyncSlackIntegrationForCustomerPrisma {
    syncSlack {
      success
      message
      customer {
        id
        slackIntegration {
          id
          type
          connected
          auth0SlackUserId
          autopopulateInterviewer
          notificationsChannelId
          receiveNotifications
          needsReauthentication
        }
      }
    }
  }
`;

export const SLACK_INTEGRATION_FOR_CUSTOMER_PRISMA = gql`
  query SlackIntegrationForCustomerPrisma {
    currentUserV2: currentUserPrisma {
      id
      organization: currentOrganization {
        id
        customer {
          id
          integration: slackIntegration {
            id
            type
            connected
            auth0SlackUserId
            notificationsChannelId
            autopopulateInterviewer
            receiveNotifications
            needsReauthentication
          }
        }
      }
    }
  }
`;

export const UPDATE_SLACK_INTEGRATION_FOR_CUSTOMER_PRISMA = gql`
  mutation UpdateSlackIntegrationForCustomerPrisma($input: UpdateSlackInput!) {
    updateSlack(input: $input) {
      success
      message
      code
      customer {
        id
        slackIntegration {
          id
          type
          connected
          auth0SlackUserId
          autopopulateInterviewer
          needsReauthentication
          notificationsChannelId
          receiveNotifications
        }
      }
    }
  }
`;
